import React, { useCallback, useState } from 'react';
import axios from 'Axios';
import Countdown from 'react-cntdwn';
import { api, toastify, clx } from 'Utils';
import { ModalBox, Button, SubmitButton, FieldMessage } from 'Elements';
import styles from 'partials/modalbox/modal-form.module.scss';

export const ModalBoxRegister = React.memo(
	({ isOpen, onClose, size, onToggleLogin }) => {
		const initialState = () => ({
			fields: {
				name: '',
				username: '',
				password: '',
				password_confirmation: '',
				mobile: '',
				code: ''
			},
			isSubmiting: false,
			getNewCode: true,
			isWaitingCode: false,
			errors: {}
		});

		const [state, setState] = useState(initialState());

		const resetState = useCallback(() => {
			setState(initialState());
		}, []);

		const handleInput = (e) => {
			const target = e.target;
			const { fields } = state;
			fields[target.name] = target.value;
			setState((prev) => ({
				...prev,
				fields
			}));
		};

		const validateForm = () => {
			let errors = {};
			let formIsValid = true;
			const { fields } = state;
			if (!fields.name) {
				formIsValid = false;
				errors['name'] = 'نام و نام خانوادگی را وارد کنید';
			}
			if (!fields.username) {
				formIsValid = false;
				errors['username'] = 'نام کاربری را وارد کنید';
			}
			if (!fields.password) {
				formIsValid = false;
				errors['password'] = 'کلمه عبور را وارد کنید';
			}
			if (!fields.password_confirmation) {
				formIsValid = false;
				errors['password_confirmation'] =
					'تکرار کلمه عبور را وارد کنید';
			}
			if (fields.password !== fields.password_confirmation) {
				formIsValid = false;
				errors['password_confirmation'] = 'کلمه عبور مطابقت ندارد';
			}
			if (!fields.mobile) {
				formIsValid = false;
				errors['mobile'] = 'شماره همراه را وارد کنید';
			}
			if (!fields.code) {
				formIsValid = false;
				errors['code'] = 'کد تایید موبایل را وارد کنید';
			}

			setState((prev) => ({
				...prev,
				errors
			}));
			return formIsValid;
		};

		const onFinishCountdown = () => {
			setState((prev) => ({
				...prev,
				getNewCode: true
			}));
		};

		const resendCode = () => {
			if (!state.fields.mobile) {
				return toastify('شماره همراه الزامی است');
			}
			setState((prev) => ({
				...prev,
				isWaitingCode: true
			}));
			const data = {
				mobile: state.fields.mobile
			};
			axios.post(api.sendSms, data).then((res) => {
				if (res.status === 200) {
					let data = res.data;
					if (data.success) {
						setState((prev) => ({
							...prev,
							getNewCode: false
						}));
						toastify(data.message, 'info');
					}
					setState((prev) => ({
						...prev,
						isWaitingCode: false
					}));
				} else {
					toastify('خطا در برقراری ارتباط با سرور');
				}
			});
		};

		const submitForm = () => {
			const data = state.fields;
			if (validateForm()) {
				setState((prev) => ({
					...prev,
					isSubmiting: true
				}));
				axios.post(api.register, data).then((res) => {
					let data = res.data;
					setState((prev) => ({
						...prev,
						isSubmiting: false
					}));
					if (data.code === 200) {
						if (data.success) {
							const token = data.result.token;
							console.log('token: ', token);
							// CurrentUser.setToken(token);
							// setToken((prevState) => ({
							// 	...prevState,
							// 	authenticated: true
							// }));
							onClose();
						} else {
							toastify(data.message);
						}
					} else {
						toastify('خطا در برقراری ارتباط با سرور');
					}
				});
			}
		};

		const handleSubmit = (e) => {
			e.preventDefault();
			submitForm();
		};

		let targetDate = new Date();
		targetDate.setMinutes(targetDate.getMinutes() + 1);

		return (
			<ModalBox
				isOpen={isOpen}
				size={size}
				onClose={onClose}
				onDestroy={resetState}>
				<header className={styles.header}>
					<h3 className={styles.headerTitle}>عضویت</h3>
				</header>
				<div className={styles.body}>
					<form className={styles.form} onSubmit={handleSubmit}>
						<div className={styles.fieldset}>
							<label htmlFor="name" className={styles.label}>
								نام
							</label>
							<input
								id="name"
								name="name"
								type="text"
								className={styles.input}
								onChange={handleInput}
							/>
							{state.errors.name && (
								<FieldMessage text={state.errors.name} />
							)}
						</div>
						<div className={styles.fieldset}>
							<label htmlFor="username" className={styles.label}>
								نام کاربری
							</label>
							<input
								id="username"
								name="username"
								type="text"
								className={[
									styles.input,
									styles.input_ltr
								].join(' ')}
								onChange={handleInput}
							/>
							{state.errors.username && (
								<FieldMessage text={state.errors.username} />
							)}
						</div>
						<div className={styles.fieldset}>
							<label htmlFor="password" className={styles.label}>
								کلمه عبور
							</label>
							<input
								id="password"
								name="password"
								type="password"
								className={[
									styles.input,
									styles.input_ltr
								].join(' ')}
								onChange={handleInput}
							/>
							{state.errors.password && (
								<FieldMessage text={state.errors.password} />
							)}
						</div>
						<div className={styles.fieldset}>
							<label
								htmlFor="password_confirmation"
								className={styles.label}>
								تکرار کلمه عبور
							</label>
							<input
								id="password_confirmation"
								name="password_confirmation"
								type="password"
								className={[
									styles.input,
									styles.input_ltr
								].join(' ')}
								onChange={handleInput}
							/>
							{state.errors.password_confirmation && (
								<FieldMessage
									text={state.errors.password_confirmation}
								/>
							)}
						</div>
						<div className={styles.fieldset}>
							<label htmlFor="mobile" className={styles.label}>
								شماره همراه
							</label>
							<div className={styles.fieldBox}>
								<input
									id="mobile"
									name="mobile"
									type="tel"
									inputMode="tel"
									className={[
										styles.input,
										styles.input_ltr
									].join(' ')}
									onChange={handleInput}
								/>
								<div className={styles.resend}>
									{!state.getNewCode && (
										<Countdown
											format={{
												minute: 'mm',
												second: 'ss'
											}}
											targetDate={targetDate}
											interval={1000}
											timeSeparator={':'}
											leadingZero
											onFinished={onFinishCountdown}
										/>
									)}
									{state.getNewCode && (
										<Button
											className={styles.btnBorder}
											disabled={state.isWaitingCode}
											onClick={resendCode}>
											{state.isWaitingCode
												? '...'
												: 'دریافت کد تایید'}
										</Button>
									)}
								</div>
							</div>
							{state.errors.mobile && (
								<FieldMessage text={state.errors.mobile} />
							)}
						</div>
						<div className={styles.fieldset}>
							<label htmlFor="code" className={styles.label}>
								کد تایید موبایل
							</label>
							<input
								id="code"
								name="code"
								type="text"
								autoComplete="one-time-code"
								inputMode="numeric"
								className={[
									styles.input,
									styles.inputSpacing
								].join(' ')}
								onChange={handleInput}
							/>
							{state.errors.code && (
								<FieldMessage text={state.errors.code} />
							)}
						</div>
						<div className={styles.fieldset}>
							<SubmitButton
								className={clx(
									styles.submit,
									styles.submitFull
								)}
								disabled={state.isSubmiting}
								title="ایجاد حساب کاربری"
							/>
						</div>
						<div className={styles.fieldset}>
							<p className={styles.text}>
								قبلا عضو شده اید؟ &nbsp;
								<Button
									className={styles.textLink}
									onClick={onToggleLogin}>
									ورود به سایت
								</Button>
							</p>
							<p className={styles.text}></p>
						</div>
					</form>
				</div>
			</ModalBox>
		);
	}
);

ModalBoxRegister.displayName = 'ModalBoxRegister';
